<template>
	<GroupMembersCard 
		:grupo="grupo"
		:integrantes="integrantes"
		@reload="reloadGrupo"
	/>
</template>

<script>
	import GroupMembersCard from './GroupMembersCard.vue';

	export default {
		name: 'GroupSideBar',
		components: {
			GroupMembersCard,
		},
		data() {
			return {
				grupo: { administradores: [] },
				integrantes: [],
			};
		},
		mounted() {
			this.reloadGrupo();
		},
		methods: {
			reloadGrupo() {
				this.$http
					.get(
						'items/grupos/' +
							this.$route.params.id_grupo +
							'?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,*'
					)
					.then((res) => {
						this.grupo = res.data.data;
						if (this.grupo.adminsitradores) {
							this.integrantes = this.grupo.integrantes.filter(
								(el) =>
									!this.grupo.administradores.find(
										(e) => e.directus_users_id.id === el.directus_users_id.id
									)
							);
						} else this.integrantes = this.grupo.integrantes;
					});
			},
			sanitizeTitle: function (title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');
				return slug;
			},
		},
	};
</script>

<style scoped>
	a {
		text-decoration: none;
		color: black;
	}

	a:hover {
		text-decoration: underline;
		color: #f15a24;
	}
	h2 {
		font-family: 'Inter';
		font-weight: bold;
		color: #707070;
		text-align: left;
	}

	.filesButton {
		text-decoration: none !important;
	}

	.annotation {
		border: 1px solid rgb(200 200 200) !important;
		margin: 8px 0px;
		border-radius: 10px;
	}

	.annotation ::v-deep img,
	.comentario ::v-deep img {
		max-width: 100% !important;
	}

	.annotation ::v-deep iframe {
		height: 250px;
	}

	.annotationText div {
		width: 100%;
	}

	.reg {
		border: 1px dashed gray;
		border-radius: 10px;
		padding: 5px;
	}
</style>
